import { validate } from '../../../utils/validate';
import { BIOMETRIC_LABEL_DICTIONARY } from './constants';

export const handleCompleteConfirmationPin = ({
  dispatchFocusInput,
  dispatchSetPin,
  dispatchUpdateError,
  formValues: { pin },
  setIsDrawerOpen,
  value,
}) => {
  const validationError = validate({
    comparisonValue: value,
    name: 'Pins',
    required: true,
    type: 'concurrentFields',
    value: pin,
  });
  if (validationError) {
    const { message } = validationError;
    dispatchUpdateError({
      subType: 'pinDrawer',
      type: 'bannerError',
      value: message,
    });
    dispatchFocusInput({ field: 'passcode' });
  } else {
    dispatchSetPin({ pin });
    setIsDrawerOpen(false);
  }
};

/**
 * Determines proper biometrics label based on the Platform OS and the supported biometric
 * authentication type(s) on the device.
 * @param {'ios'|'android'} platformOS
 * @param {{
 *  face: boolean,
 *  fingerprint: boolean,
 *  iris: boolean,
 * }} supportedBiometricAuthenticationTypes
 * @returns {string} proper biometric label (empty string as fallback)
 */
export const getProperBiometricLabel = (platformOS, supportedBiometricAuthenticationTypes) => {
  const relevantPlatforms = ['ios', 'android'];
  if (!relevantPlatforms.includes(platformOS)) return '';
  const supportedTypesEntries = Object
    .entries(supportedBiometricAuthenticationTypes)
    .filter(([, isSupported]) => isSupported);
  if (!supportedTypesEntries.length) return '';
  if (supportedTypesEntries.length > 1) return BIOMETRIC_LABEL_DICTIONARY[platformOS].multiple;
  const [[onlySupportedType]] = supportedTypesEntries;
  return BIOMETRIC_LABEL_DICTIONARY[platformOS][onlySupportedType];
};
